module.exports = __webpack_public_path__ + "b71cd1494997f167077293ec920a7608.png";